import React from 'react';

import ScorerItem from './ScorerItem';
import EmptyList from '../useful/EmptyList';

const Scorers = (props) => {

    const { teams, players } = props;

    const tableHead =
        <thead className="">
            <tr >
                <th className="text-center" style={{ width: 32 }}>#</th>
                <th className="pl-0" >NOMBRE</th>
                <th className="text-center" style={{ width: 45 }}>Goles</th>
            </tr>
        </thead>

    const playersWithStatistics = (players || []).filter(item => {
        return item && item.position !== "Director Técnico"
            && item.statistic
            && item.statistic.goals
            && item.statistic.goals > 0;
    })

    playersWithStatistics.sort((a, b) => b.statistic.goals - a.statistic.goals)

    const listView = (playersWithStatistics.length > 0) ?
        playersWithStatistics.map((item, i) => {
            const team = teams.find(team => team.uid == item.teamUid);
            return (
                <ScorerItem key={i} item={item} team={team} />
            )
        })
        :
        <tr>
            <td colSpan="10"><EmptyList /></td>
        </tr>

    return (
        <div className="">
            <div className="row justify-content-between m-0 mb-2 small pt-1 pb-1">
                <span className="col-auto align-self-center font-weight-bolder m-0 p-0">
                    Maximos goleadores
                </span>
            </div>

            <div className="table-responsive-sm">
                <table className="table table-sm small ">
                    {tableHead}
                    <tbody>
                        {listView}
                    </tbody>
                </table>
            </div>

        </div>
    )

}

export default Scorers;